import { FileInfo } from "components/dashboard/product-template-table/utils/interfaces";

export type ObjectDatasetDto = ObjectDatasetReq & {
  createdAt: string;
  data: ObjectDatasetDataDto[];
};

export type ObjectDatasetReq = {
  identifier: string;
  type: ObjectDatasetType;
  title: string;
};

export type ObjectDatasetDataReq = {
  identifier: string;
  fileInfos: FileInfo[];
};

export type ObjectDatasetDataDto = ObjectDatasetDataReq & {
  timestamp: string;
  updatedAt: string;
  rootPath: string;
};

export const objectDatasetTypes = ["GENERAL", "IMAGE", "JSON", "HTML"] as const;

export type ObjectDatasetType = (typeof objectDatasetTypes)[number];
